import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StringWithLabelComponent } from "./string-with-label.component";

@NgModule({
    declarations: [
        StringWithLabelComponent,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        StringWithLabelComponent,
    ],
    providers: [],
})
export class StringWithLabelModule {

}
